import { getLicenses } from 'redux/rootSelectors';
import { createSelector } from 'reselect';

const getLicenseByResume = createSelector([getLicenses], license => license.licenseResume);
const getExpiredLicenses = createSelector([getLicenses], license => license.expiredLicenses);

export { getLicenseByResume, getExpiredLicenses };
